// opervex-frontend/src/Opervex/Report/index.js

import _GoodsMovement from "./GoodsMovement";
import _GoodsMovementFull from "./GoodsMovementFull";
import _SalesOrder from "./SalesOrder";
import _ServiceOrder from "./ServiceOrder";
import _StockSerial from "./StockSerial";
import _Stock from "./Stock";
import _StockSerialDays from "./StockSerialDays";

class Report {
  #api;

  constructor(api) {
    this.#api = api;

    this.GoodsMovement = new _GoodsMovement(this.#api);
    this.GoodsMovementFull = new _GoodsMovementFull(this.#api);
    this.SalesOrder = new _SalesOrder(this.#api);
    this.ServiceOrder = new _ServiceOrder(this.#api);
    this.StockSerial = new _StockSerial(this.#api);
    this.Stock = new _Stock(this.#api);
    this.StockSerialDays = new _StockSerialDays(this.#api);
  }
}

export default Report;
